// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {AlertBarMessageList} from './alert-bar-message-list';
import AlertMessage from '../../state/alert-message';
import ErrorAlertBar from '../alert-bar/error-alert-bar';
import {FormattedMessage} from 'react-intl';

const getDismissHandler = onDismiss =>
    () => {

        onDismiss('error');

    };

export const ErrorMessageContainer = props => {

    const title = props.errorMessages.length > 1 ?
        <FormattedMessage id='ERROR_MESSAGES_TITLE'/> :
        <FormattedMessage id='ERROR_MESSAGE_TITLE'/>;

    const content = props.errorMessages.length > 1 ? (
        <AlertBarMessageList messages={props.errorMessages}/>
    ) :
    props.errorMessages.length > 0 && props.errorMessages[0].message;

    return (
        <div className='error-message-container'>
            <ErrorAlertBar
                alertTitle={title}
                dismissHandler={getDismissHandler(props.onDismiss)}
            >
                {content}
            </ErrorAlertBar>
        </div>
    );

};

ErrorMessageContainer.displayName = 'ErrorMessageContainer';

ErrorMessageContainer.propTypes = {
    errorMessages: PropTypes.arrayOf(
        PropTypes.instanceOf(AlertMessage)
    ).isRequired,
    onDismiss: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/shared/components/alert-bar-container/error-message-container.js